import { Radio } from 'antd';
import { Text } from 'components/mvp-typography';
import { PatientInfoState } from 'features/patient/_utils/patient-info/patient-info-slice-types';
import { useGetClinicAllInfo } from 'lib/hooks/tanstack/use-getClinicInfo';
import { useEffect, useMemo, useState } from 'react';
import { PayForAssessmentWithWrapper } from './display-payforassessment';
import {
  ASSESSMENT_UNLOCK_PIPELINES,
  UnlockPipelineType
} from './unlock-pipelines';

export function PatientHomeAssessmentBlockedV1Dot2(props: {
  patientInfo: PatientInfoState;
  refetchPatientInfo: () => void;
}) {
  const [mode, setMode] = useState<UnlockPipelineType | 'loading'>('loading');

  const clinicId = props.patientInfo.patient.clinics?.at(0);
  const clinicInfo = useGetClinicAllInfo(clinicId!);

  const availableUnlockPipelines = useMemo(() => {
    const clinic = clinicInfo.clinicInfo?.clinic;
    if (!clinic) return [];

    return ASSESSMENT_UNLOCK_PIPELINES.filter(_ => _.include({ clinic }));
  }, [clinicInfo.clinicInfo?.clinic]);

  /**
   * 2025-12-22 Urgently requested functionality
   * The ability to disable the visual display of the "activate assessment in clinic" option on the Test-Taker Home page
   */
  useEffect(() => {
    if (availableUnlockPipelines.length === 0) {
      setMode('loading');
      return;
    }

    setMode(availableUnlockPipelines[0].value);
  }, [availableUnlockPipelines]);

  if (props.patientInfo.isLoading) return null;

  return (
    <>
      <div
        style={{
          background: 'white',
          padding: '1.2rem',
          borderRadius: 5,
          maxWidth: 650,
          width: '100%',
          color: 'black',
          fontWeight: 'bold'
        }}
      >
        <Text>Your assessment is not activated.</Text>
        {
          /**
           * 2026-01-27 https://trello.com/c/WvLEsM9b/490
           * Only show this text when the activate-in-clinic option is available.
           */
          availableUnlockPipelines.find(_ => _.value == 'clinic') && (
            <Text>
              If you wish to take the assessment at home ahead of your in-clinic
              appointment, please contact the clinic to activate your
              assessment.
            </Text>
          )
        }

        <br></br>
        <br></br>
        {
          /**
           * Case 1: Do not show any pipeline options if there is only one option
           */
          availableUnlockPipelines.length === 1 ? (
            <></>
          ) : (
            /**
             * Case 2: Allow the user to select a pipeline option
             */
            <Radio.Group value={mode} onChange={e => setMode(e.target.value)}>
              {availableUnlockPipelines.map(pipeline => (
                <Radio key={pipeline.value} value={pipeline.value}>
                  {pipeline.label}
                </Radio>
              ))}
            </Radio.Group>
          )
        }

        {mode === 'clinic' && (
          <Text>
            The assessment will be activated when you arrive to the clinic for
            your appointment.
          </Text>
        )}
        {mode === 'payment' && (
          <PayForAssessmentWithWrapper
            patientId={props.patientInfo.patient.id}
            clinicId={clinicId}
            onSuccess={() => {
              // Wait before changing the page state
              setTimeout(() => {
                props.refetchPatientInfo();
              }, 1000 * 5);
            }}
          />
        )}
      </div>
    </>
  );
}
